export const formName = 'CASH_BANKS';
